import type { LocaleDictionary } from "@/i18n/types";

const nsAppJA = {
  loading: {
    defaultText: "データを読み込んでいます...",
    organizations: "組織一覧を読み込んでいます...",
    frontendAddon: "フロントエンドアドオンを読み込んでいます...",
  },
  undo: {
    actionLabel: "元に戻す",
    inProgress: "操作を取り消しています",
    success: "操作を取り消しました",
    error: "操作を取り消せませんでした。もう一度お試しください。",
  },
} satisfies LocaleDictionary;

export default nsAppJA;
